import { createSlice } from '@reduxjs/toolkit';

const ResultsSlice = createSlice({
    name: 'resultSlice',
    initialState: {
        isCompleted: false,
        results: {}
    },
    reducers:{
        resultsFormating: (state,action)=>{
            state.isCompleted = true
            state.results = action.payload
        },
        clearResults: (state) => {
            state.isCompleted = false
            state.results = {}
        }
    }
})

export const { resultsFormating, clearResults } = ResultsSlice.actions;
export default ResultsSlice